import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentIds"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import OwningTeamField from '.';
export function AssetOwningTeamField(_ref) {
  var _ref$contentIds = _ref.contentIds,
    contentIds = _ref$contentIds === void 0 ? [] : _ref$contentIds,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(OwningTeamField, _extends({
    contentType: "asset",
    description: t('panel_owning_team_description_asset', {
      count: contentIds.length
    }),
    contentIds: contentIds
  }, otherProps));
}
export default AssetOwningTeamField;